import { useEffect } from "react";

export function useParallax() {
  useEffect(() => {
    function onScroll() {
      const y = window.scrollY;
      document.querySelectorAll(".parallax-up").forEach((el) => {
        el.style.setProperty("--scroll-up", `${y * -0.05}px`);
      });
      document.querySelectorAll(".parallax-down").forEach((el) => {
        el.style.setProperty("--scroll-down", `${y * 0.05}px`);
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
}
